import {
    MYALERTS_SUBSCRIBE_REQUEST,
    MYALERTS_CLEAR_DATA,
    MYALERTS_LOADER,
} from '../actionTypes/MyAlertsActionTypes';

export const signupForAlerts = (email, sku, link, source, featureFlags = {}, sourceMiniPDP) => ({
    type: MYALERTS_SUBSCRIBE_REQUEST,
    payload: { email, sku, link, source, featureFlags, sourceMiniPDP },
});

export const clearData = (payload) => ({
    type: MYALERTS_CLEAR_DATA,
    payload,
});

export const myAlertsLoader = (payload) => ({
    type: MYALERTS_LOADER,
    payload,
});
